export default __webpack_public_path__ + "static/media/Aura-Egg__94.41b48c03.png";